const EARTH_RADIUS_M = 6_371_000;

/**
 * Z výchozího bodu posune o `distance` metrů ve směru `bearing` (radiány, 0 = sever).
 * Vrací nové [lat, lon] ve stupních. Haversine forward formula.
 */
export function destinationPoint(
    lat: number,
    lon: number,
    distance: number,
    bearing: number,
): { lat: number; lon: number } {
    const phi1 = (lat * Math.PI) / 180;
    const lambda1 = (lon * Math.PI) / 180;
    const delta = distance / EARTH_RADIUS_M;

    const phi2 = Math.asin(
        Math.sin(phi1) * Math.cos(delta) + Math.cos(phi1) * Math.sin(delta) * Math.cos(bearing),
    );
    const lambda2 =
        lambda1 +
        Math.atan2(
            Math.sin(bearing) * Math.sin(delta) * Math.cos(phi1),
            Math.cos(delta) - Math.sin(phi1) * Math.sin(phi2),
        );

    return {
        lat: (phi2 * 180) / Math.PI,
        lon: (((lambda2 * 180) / Math.PI + 540) % 360) - 180,
    };
}
